export default __webpack_public_path__ + "static/media/sound_transition.60592fa7.wav";